/**
 * Retrieves the display data for a lookup field based on the provided properties.
 *
 * @param {Object} props - The properties for the lookup field.
 * @param {Object} props.currentColumn - The current field configuration.
 * @param {Object} props.lookedupData - 
 * @param {Object} props.lookedUpTuple - The data tuple for that row without lookups.
 * @param {string} props.siteUUIDToUse - The site UUID to use for lookups.
 * @param {Object} props.secondaryLookupFields - Additional lookup field configurations.
 * @param {Object} props.secondaryComputedLookupData - Lookup data that is grouped by siteUUID and then resource name.
 * @returns {string|undefined} The display data for the lookup field.
 */
/*

*/

export default function getDisplayDataForLookupField(props) {
    const { 
        currentColumn, 
        lookedupData, 
        lookedUpTuple, 
        siteUUIDToUse, 
        secondaryLookupFields,
        secondaryComputedLookupData,
     } = props;

    let displayData;

    if (currentColumn.resourceDisplayKey !== undefined && currentColumn.resourceDisplayKey !== null) {
        displayData = lookedUpTuple?.[currentColumn.resourceDisplayKey];

        if (displayData == null || displayData == undefined) {
            displayData = "";
        }

        const secondaryLookup = secondaryLookupFields?.[currentColumn.linksToSiteUUID]?.[currentColumn.linksToResource]?.[currentColumn.resourceDisplayKey];
        if(secondaryLookup) {
            let alternativeDisplayData = secondaryComputedLookupData?.[currentColumn?.linksToSiteUUID]?.[secondaryLookup.linksToResource]?.[displayData]?.[secondaryLookup.resourceDisplayKey];

            if(alternativeDisplayData != null && alternativeDisplayData != undefined) {
                displayData = alternativeDisplayData;
            }
        }

        if (typeof displayData !== "string") {
            displayData = displayData.toString();
        }
    } 
    
    else if (Array.isArray(currentColumn.resourceDisplayKeysMultiple) && currentColumn.resourceDisplayKeysMultiple.length > 0) {
        displayData = currentColumn.resourceDisplayKeysMultiple.reduce((acc, key) => {
            if (key[0] == "$") {
                const correctKey = key.substr(1);
                let lookedUpValue = lookedUpTuple?.[correctKey];

                const secondaryLookupInformation = secondaryLookupFields?.[siteUUIDToUse]?.[currentColumn.linksToResource]?.[correctKey];

                if (secondaryLookupInformation) {
                    const secondaryLookupResource = secondaryLookupInformation.linksToResource;
                    const secondaryLookupKey = secondaryLookupInformation.resourceDisplayKey;

                    lookedUpValue = lookedupData?.[siteUUIDToUse]?.[correctKey]?.[lookedUpValue]?.[secondaryLookupKey];

                    if(lookedUpValue == undefined) {
                        lookedUpValue = secondaryComputedLookupData?.[siteUUIDToUse]?.[secondaryLookupResource]?.[lookedUpTuple?.[correctKey]]?.[secondaryLookupKey];
                    }
                }

                // Sometimes the lookedUpValue can be undefined, so we set it to an empty string
                // to avoid rendering issues.
                lookedUpValue = lookedUpValue == undefined ? "" : lookedUpValue;

                return `${acc}${lookedUpValue}`;
            }

            return `${acc}${key}`;
        }, "");
    }

    return displayData;
}